import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { ConstantModel } from '../kpi-models/constants.model';
import { UOMData } from 'src/assets/UOMData';
import { GlobalService } from '../../services/global.service';
import { Title } from '@angular/platform-browser';
import { HttpService } from '../../services/http.service';
import { Globals } from '../../models/globals.model';
import { AlertComponent } from '../../common/alert/alert.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KPIFormulaBuilderService } from 'src/app/services/kpi-formula-builder.service';

@Component({
  selector: 'app-constant-modal',
  templateUrl: './constant-modal.component.html',
  styleUrls: ['./constant-modal.component.css']
})
export class ConstantModalComponent implements OnInit {

  isLoader = false;
  unitList: string[];
  unitTypeList: string[];
  mode: string;
  apiUri: string;
  graphUri: string;

  public constantsForm = new UntypedFormGroup({
    constantId: new UntypedFormControl(''),
    value: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    uom: new UntypedFormControl({ value: '', disabled: true }, Validators.required),
    lastModifiedBy: new UntypedFormControl({ value: '', disabled: true }, Validators.required)
  });

  constructor(public fb: UntypedFormBuilder, public globalService: GlobalService, private readonly kpiFormulaService: KPIFormulaBuilderService,
    private readonly titleService: Title, private readonly httpService: HttpService, public global: Globals,
    public dialogRef: MatDialogRef<ConstantModalComponent>, @Inject(MAT_DIALOG_DATA) public data: ConstantModel) {
    titleService.setTitle('Constants');
    this.unitTypeList = Object.keys(UOMData);
    this.apiUri = this.global.config.foundationPlatformApi_client_resourceUri;
    this.graphUri = this.global.config.graphApi_client_resourceUri;
  }

  ngOnInit(): void {
    if (this.globalService.isNotNullObject(this.data)) {
      this.mode = 'edit';
      this.loadEditForm(this.data);
    } else {
      this.mode = 'add';
      this.loadEmptyCreateForm();
    }
  }

  /**Loads empty create form */
  loadEmptyCreateForm() {
    this.constantsForm = this.fb.group({
      constantId: ['', Validators.required],
      value: [{ value: '', disabled: true }, Validators.required],
      unitType: [{ value: '', disabled: true }, Validators.required],
      uom: [{ value: '', disabled: true }, Validators.required]
    });
  }

  /**Loads edit form for constants */
  loadEditForm(data: ConstantModel) {
    this.isLoader = true;
    const uomMap = Object.keys(UOMData).map(key => ({ type: key, value: UOMData[key] }));
    const uomrequired = uomMap.filter(function (elem) {
      return elem.value.includes(data.uom);
    });
    let uType = '';
    let eUnit = '';
    if (uomrequired && uomrequired.length > 0) {
      uType = uomrequired[0].type;
      eUnit = data.uom;
    }
    this.constantsForm = this.fb.group({
      constantId: new UntypedFormControl(data.constantId, Validators.required),
      value: new UntypedFormControl(data.value, Validators.required),
      unitType: new UntypedFormControl(uType, Validators.required),
      uom: new UntypedFormControl(eUnit, Validators.required)
    });
    this.constantsForm.get('constantId').disable();
    this.populateUOM();
    this.isLoader = false;
  }

  populateUOM() {
    this.constantsForm.get('uom').enable();
    this.unitList = UOMData[this.constantsForm.get('unitType').value];
  }

  /**Saves name of constant */
  onNameSave() {
    this.constantsForm.get('value').enable();
  }

  /**Saves value of constant */
  onValueSave() {
    this.constantsForm.get('unitType').enable();
  }

  /**Saves data for constants */
  saveFormula() {
    this.isLoader = true;
    const constants: ConstantModel = this.constantsForm.value;
    constants.lastModifiedBy = this.globalService.loggedInUser;
    if (this.mode === 'add') {
      constants.createdBy = this.globalService.loggedInUser;
      this.kpiFormulaService.saveConstantFormula(constants).subscribe((data: any): void => {
        if (data) {
          this.onCancelClick();
          this.globalService.showAlert(AlertComponent, { success: true, message: 'Constants for ' + constants.constantId + ' saved successfully.' });
          this.isLoader = false;
        } else {
          this.onCancelClick();
          this.isLoader = false;
        }
      }, (error) => {
        this.isLoader = false;
      });
    } else if (this.mode === 'edit') {
      constants.createdBy = this.data.createdBy;
      constants.constantId = this.data.constantId;
      this.kpiFormulaService.updateConstantFormula(constants).subscribe((data: any): void => {
        if (data) {
          this.isLoader = false;
          this.onCancelClick();
          this.globalService.showAlert(AlertComponent, { success: true, message: 'Constants for ' + constants.constantId + ' updated successfully.' });
          this.isLoader = false;
        } else {
          this.onCancelClick();
          this.isLoader = false;
        }
      }, (error) => {
        this.isLoader = false;
      });
    }
  }

  /**Checks if save button should be enabled */
  enableSave(): boolean {
    return false;
  }

  /**Closes the modal */
  onCancelClick(): void {
    this.dialogRef.close();
  }

}
